// スライム：ゆっくり追跡、2フレームのぷよぷよアニメ
import Phaser from 'phaser';
import { Enemy } from '../Enemy';

export class Slime extends Enemy {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, 'slime');
    this.anims.play('slime-idle');
  }

  static defineAnimations(scene: Phaser.Scene): void {
    if (scene.anims.exists('slime-idle')) return;
    scene.anims.create({
      key: 'slime-idle',
      frames: scene.anims.generateFrameNumbers('enemy_slime', { start: 0, end: 1 }),
      frameRate: 3,
      repeat: -1,
    });
  }
}
